<template>
  <div class="planManage">

      <a-page-header style="border-bottom: 1px solid rgb(235, 237, 240)" title="订单配额查询" sub-title="查询小店随心推使用中订单配额信息" />

      <div style="padding:10px 0px">

      <div class="searchWapper">
            <a-form-model layout="inline" :model="form">
              <a-form-model-item label="" style="padding-top: 3px;">
                <AwemeList :dataSource="advertiserList" action="setAdvertiserId" @getAdvertiserId="getAdvertiserId"
                  v-if="advertiserList.length > 0" />
              </a-form-model-item>
 
              <a-form-model-item label="">
                <a-button type="primary" style="margin-right: 15px" @click="getData">
                  查询
                </a-button>
                <a-button style="margin-right: 15px" >重置</a-button> 
              </a-form-model-item>
            </a-form-model>
          </div> 

        <div class="content" style="margin-top:20px">
          <h3>查询结果：</h3>
          <h3 >最高月消耗：<span style="color: red;">{{result.max_cost}} </span>元  订单配额：<span style="color: red;">{{result.sum_quota}} </span>使用中订单数：<span style="color: red;"> {{result.used_quota}} </span>当前所在配额档位：<span style="color: red;">{{result.quota_gear}}</span></h3>
        </div>
        <div class="content">
          <h3 >每日终止配额：<span style="color: red;">{{result.terminate_quota_info.terminate_quota_sum}} </span> 今日终止订单数：<span style="color: red;"> {{result.terminate_quota_info.terminate_quota_used}} </span>
            今日剩余终止订单数量：<span style="color: red;">{{result.terminate_quota_info.terminate_quota_sum-result.terminate_quota_info.terminate_quota_used}} </span></h3>
        </div>
        
    <div style="text-align: left;">
      <img src="@images/quato1.png" alt="" class="quato" />
      <img src="@images/quato2.png" alt="" class="quato" />
      <img src="@images/quato3.png" alt="" class="quato" />
      <img src="@images/quato4.png" alt="" class="quato" /> 
    </div>
    </div>

  </div>
</template>
<script>
import { qcApi, requestHttp } from '@utils/index';
import { Modal } from 'ant-design-vue';
import { FormModel } from 'ant-design-vue';
import awemeList from '../batchCreatePlan/components/awemeList.vue';

export default {
  name: 'orderQuat',
  props: {},

  data() {
    return {
      advertiserList: [],
      advertiser_id: '',

      form: { 
      },

      result:{
        used_quota:0,
        sum_quota:0,
        max_cost:0,
        quota_gear:0,
        terminate_quota_info:{
          terminate_quota_sum:0,
          terminate_quota_used:0
        }
      }


    };
  },

  components: {
    AwemeList: awemeList,
  },

  watch: {},
  async mounted() {
    await this.getAdvertiserList();
  },
  methods: {
    getAdvertiserId(advertiser_id) {
      console.log('子组件传回的值', advertiser_id)
      this.advertiser_id = advertiser_id
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async getAdvertiserList() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_ADVERTISER_LIST}`,
        method: 'POST',
        params: {
          type: 'SXT',
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      this.advertiserList = data.list
      if (data.list.length == 0) {
        Modal.confirm({
          title: '提醒',
          content: '您尚未授权随心推账户，是否前往授权？',
          onOk: () => {
            this.$router.replace('/sxt_account');
          },
        });
      } else {
        this.advertiser_id = data.list[0].advertiser_id
        this.getData()
      }
    },
    async getData() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.AWEME_ORDER_QUATO_GET}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id, 
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      this.result = data
    }
  },
};
</script>

<style lang="less" scoped>
.ant-form-item {
  padding-left: 20px;
}

.ant-form-item-control {
  text-align: left;
}
.search{
  padding: 20px;
  text-align: left;
}

.planManage {
  .searchWapper {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    .selectType {
      width: 166px;
    }
  }

  h3 {
    text-align: left;
    padding-left: 30px;
    font-weight: bold;
  }

  .searchResult {
    margin-top: 20px;
  }
}

.ant-form-item-control {
  text-align: left;
}

.videoimg {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
}
</style>
